module.exports = __webpack_public_path__ + "static/media/hs_06.70d4208d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_06.jpg
// module id = 5937
// module chunks = 0